import type { QueryClient } from '@tanstack/react-query';
import type { PlayerRewardDto, PlayerRewardParams } from '@/queries/playerGamificationRewards/playerGamificationRewards.schema';
import { playerGamificationRewardsOptions } from '@/queries/playerGamificationRewards/playerGamificationRewards.queries';
import { GamificationRewardType } from '@/queries/playerGamificationRewards/playerGamificationRewards.schema';

const STATUS_UP_REWARD_PAGE_SIZE = 10;

const statusUpParams: PlayerRewardParams = {
  filter: {
    type: GamificationRewardType.StatusUp,
    claimedAt: { $isnull: true },
  },
  limit: STATUS_UP_REWARD_PAGE_SIZE,
  sort: { createdAt: 'desc' },
};

export const getStatusUpRewardStatusId = (reward: PlayerRewardDto) =>
  'statusId' in reward.config ? reward.config.statusId : undefined;

export const getUnclaimedStatusUpRewards = async (queryClient: QueryClient) => {
  const rewards: PlayerRewardDto[] = [];
  let page = 1;

  while (true) {
    const data = await queryClient.fetchQuery(
      playerGamificationRewardsOptions.meRewards({ ...statusUpParams, page }, { staleTime: 0 }),
    );
    rewards.push(...data.items);

    if (!data.hasNextPage) {
      return rewards;
    }
    page += 1;
  }
};
